export const dashboardConstants = {
  GET_DASHBOARD_STATES_SUCCESS: 'GET_DASHBOARD_STATES_SUCCESS'
};
